var xgrid = function () { };
xgrid.prototype = {
    init: function (el) {
        var me = this;
        me.el = el;
        el[0].xgrid = me; // kad turėti xgrid objektą prie elemento
        el.addClass('xgrid_initialized');
        me.dataset = el.data('dataset');
        me.datasetParams = el.data('params');

        me.render(el);

        me.listeners = Object.create(me._listeners).init(me);
        me.ajax = Object.create(me._ajax).init(me);
        me.columnResize = Object.create(me._columnResize).init($('.xgrid_header', me.el));
    },
    render: function (el) {
        var me = this;

        me.body = {
            'left': $('div.xgrid_table__body_left', el),
            'center': $('div.xgrid_table__body_center', el),
            'right': $('div.xgrid_table__body_right', el),
        };

        me.body.all = me.body.left.add(me.body.center).add(me.body.right);

        me.header = {
            'left': $('.xgrid_table__header_left:last', el),
            'center': $('.xgrid_table__header_center:last', el),
            'right': $('.xgrid_table__header_right:last', el),
        };

        me.header.all = me.header.left.add(me.header.center).add(me.header.right);

        me.elements = {
            'sidebar': {
                'buttons': {
                    'filters': $('.xgrid_side-menu__button:first', el),
                    'columns': $('.xgrid_side-menu__button:last', el),
                },
                'dropdown': $('.xgrid_side-menu__dropdown', el),
            },
            'header': $('.xgrid__header', el),
            'summary': $('.summary_row', el),
            'footer': $('.xgrid_footer', el),
        };

        me.config = {
            header: {
                'left': (me.header.left.length !== 0),
                'center': true,
                'right': (me.header.right.length !== 0),
            },
            columns: {
                'left': me.header.left.find('.xgrid_header').length / 2,
                'center': me.header.center.find('.xgrid_header').length / 2,
                'right': me.header.right.find('.xgrid_header').length / 2,
            },
        };

        me.filterInputs = $('input.xgrid_filter-input', me.header.all);
    },
    /**
     * Grąžinamos sužymėtos reikšmės
     */
    getCheckedValues: function (array = false, separator = ',') {
        var checked = [],
            dataAttr = array ? 'json' : 'pk';

        this.body.all
            .find('.xgrid_row-checkbox:checked')
            .each(function (_, chk) {
                checked.push($(chk).closest('.xgrid_table__row').data(dataAttr));
            });

        if (array) return checked;

        return checked.join(separator);
    },
    /**
     * Aktyvus filtrai, kuriuos suveda paieskos laukuose
     */
    getActiveSearchFilters: function () {
        var me = this,
            inputs = me.filterInputs,
            filter = {};

        inputs.each(function (_, el) {
            var $el = $(el),
                name = $el.attr('name'),
                value = $el.val();

            if (!value) return;

            filter[name] = value;
        });

        return filter;
    },
    _listeners: {
        init: function (me) {
            this.me = me;

            this.sorting();
            this.sortable();
            this.cellSubmenu();
            this.scrolls();
            this.sidebar();
            this.subFilter();
            this.filter();
            this.topFilter();
            this.archive();
            this.initBody();

            this.excel();

            return this;
        },
        /**
         * Atskirta, nes reikia priskirti event'us po body reload
         */
        initBody: function () {
            this.rowClick();
            this.toggleCheckbox();
            this.excel();
        },
        hover: function () {
            var listeners = this,
                me = listeners.me;
        },
        scrolls: function () {
            var listeners = this,
                me = listeners.me,
                body = me.body,
                header = me.header,
                bodys = body.all,
                isSyncingLeft = false, //kritiskai svarbu
                isSyncingCenter = false, //kritiskai svarbu
                currentScrollLeft = 0,
                config = me.config;
            // debugger;
            $('.xgrid_table-view .xgrid_table__header').scrollbar();
            let summary_row = $('.xgrid_table-view .summary_row .xgrid_table__row');
            summary_row.scrollbar();
            let summary_row_visible = summary_row.first();

            if (!config.header.left && !config.header.right) {
                body.center.scrollbar();
                body.center.on('scroll', function (event) {
                    if (me.ajax.loading) {
                        return;
                    }

                    let height = this.clientHeight,
                        scrollHeight = this.scrollHeight,
                        scrollTop = this.scrollTop,
                        scrollLeft = this.scrollLeft,
                        target = $(event.currentTarget),
                        direction = 'vertical';

                    if (scrollLeft != currentScrollLeft) {
                        currentScrollLeft = scrollLeft;
                        header.center[0].scrollLeft = scrollLeft;
                        summary_row_visible[0].scrollLeft = scrollLeft;
                    }

                    // reikalinga paklaida, nes ne visada pataikydavo ant 0 (?)
                    // cia gali buti bug, kad spamins requestus

                    // TEST
                    if (scrollTop === 0) return;
                    if ((scrollHeight - (height + scrollTop)) < 3 && scrollHeight != height) {
                        me.ajax.scroll();
                    }

                });

                return;
            }
            bodys.scrollbar({
                autoScrollSize: false,
            });

            bodys.on('scroll', function (event) {
                let height = this.clientHeight,
                    scrollHeight = this.scrollHeight,
                    scrollTop = this.scrollTop,
                    scrollLeft = this.scrollLeft,
                    target = $(event.currentTarget),
                    direction = 'vertical';

                if (scrollLeft != currentScrollLeft) {
                    direction = 'horizontal';
                    currentScrollLeft = scrollLeft;
                }

                if (direction === 'vertical') {
                    if (target.is(body.center)) {
                        if (!isSyncingCenter) { //idomi logika, bet taip veikia
                            isSyncingLeft = true;
                            body.left[0].scrollTop = scrollTop;
                        }
                        isSyncingCenter = false;
                        return;
                    } else if (target.is(body.left)) { //idomi logika, bet taip veikia
                        if (!isSyncingLeft) {
                            isSyncingCenter = true;
                            body.center[0].scrollTop = scrollTop;
                        }
                        isSyncingLeft = false;
                        return;
                    } else if (target.is(body.right)) {

                    }
                } else {
                    if (target.is(body.center)) {
                        header.center[0].scrollLeft = scrollLeft;
                    }
                }
            });
        },
        filter: function () {
            var me = this.me,
                el = me.el,
                inputs = $('input.xgrid_filter-input', me.header.all),
                filter = {};

            inputs.each(function (e) {
                var input = $(this),
                    type = input.data('type') || 'text',
                    name = input.attr('name');

                if (type === 'text' || type === 'xnumber') {
                    input.off('keyup').keyup(function (e) {
                        if (e.which === 13) {
                            filter = me.getActiveSearchFilters();
                            // filter[name] = input.val();
                            me.ajax.filter(filter, false);
                        }
                    });
                } else if (type === 'xdaterange') {
                    // datos pasirinkimo filtras
                    input
                        .on('apply.daterangepicker', function () {
                            filter = me.getActiveSearchFilters();
                            // filter[name] = input.val();
                            me.ajax.filter(filter, false);
                        })
                        .off('keyup')
                        .keyup(function (e) {
                            if (e.which === 13) {
                                filter = me.getActiveSearchFilters();
                                // filter[name] = input.val();
                                me.ajax.filter(filter, false);
                            }
                        });
                }
            });
        },
        subFilter: function () {
            var me = this.me,
                el = me.el;

            $('input.xgrid_search-input', el).on('keyup', function (e) {
                jQuery.expr[':'].iContains = function (a, i, m) {
                    return (
                        jQuery(a)
                            .text()
                            .toUpperCase()
                            .indexOf(m[3].toUpperCase()) >= 0
                    );
                };

                var inputVal = $(this).val(),
                    notContains = $('.xgrid_checkbox-item').find(
                        'label:not(:iContains(' + inputVal + '))'
                    ),
                    contains = $('.xgrid_checkbox-item').find(
                        'label:iContains(' + inputVal + ')'
                    );

                notContains.parent().hide();
                contains.parent().show();
            });
        },
        topFilter: function () {
            var me = this.me;

            $('.xgrid_top-filter', me.elements.header).click(function () {
                var btn = $(this),
                    id = btn.data('id'),
                    filter = btn.data('filter'),
                    ajaxData = {
                        pk: pk, // po ajax.filter dataset main.php nebeturi pk (?)
                    };

                if (id) {
                    ajaxData[filter] = id;
                } else {
                    delete me.ajax.config.data[filter];
                }

                // reikia atskirti grupes
                $(btn)
                    .addClass('active').
                    siblings()
                    .removeClass('active');

                me.ajax.filter(ajaxData);
            });
        },
        sidebar: function () {
            var me = this.me,
                elements = me.elements.sidebar,
                el = me.el;

            //xlog(elements);


            $('[class^=xgrid_dropdown-menu__]', el).click(function (event) {
                event.stopPropagation();
            });
            //atidaro filtrus;
            elements.buttons.filters.click(function (event) {
                event.stopPropagation();
                elements.dropdown.removeClass('active');
                $(event.currentTarget).parent().toggleClass('active');
                $(document).one('click', function (event) {
                    elements.dropdown.removeClass('active');
                });
            });

            elements.buttons.columns.click(function (event) {
                event.stopPropagation();
                elements.dropdown.removeClass('active');
                $(event.currentTarget).parent().toggleClass('active');
                $(document).one('click', function (event) {
                    elements.dropdown.removeClass('active');
                });
            });

            //atidaro konkretu filtra
            $('button[class^=xgrid_dropdown-menu__]', el).click(function (event) {
                event.stopPropagation();
                let button = $(this),
                    details = button.next('div.xgrid_dropdown-menu__filter-details'),
                    list = details.find('div:first'),
                    search = details.find('button.xgrid_search_button'),
                    form = button.parent('form');


                //debugger;
                $('div.xgrid_dropdown-menu__filter-details').not(details).removeClass('active'); //toglina, kad butu atidarytas vienas filtras vienu metu

                if (button.hasClass('loaded')) {
                    details.toggleClass('active');
                    return;
                }

                var filter = button.data('filter'),
                    tpl = button.data('tpl'); // failo pavadinimas

                me.ajax.loadFilter(tpl, list);

                button.addClass('loaded');
                details.toggleClass('active');

                search.click(function (e) {
                    var filterData = form.serializeObject();
                    // nepazymeta jokia reiksme
                    if ($.isEmptyObject(filterData) && me.ajax.config.data[filter]) {
                        delete me.ajax.config.data[filter];
                    }
                    me.ajax.filter(filterData);
                });

            });
        },
        sorting: function () {
            var me = this.me,
                elements = me.elements.sidebar,
                el = me.el;

            $('.sorting', el).off('click').click(function (event) {
                if ($(event.target).is('.checkboxSort')) {

                    let checkbox = $(this).find('input[type=checkbox]');
                    checkbox.click();
                    return;
                }

                let target = $(event.currentTarget),
                    sortingIcon = target.children('.xgrid_sorting-arrow'),
                    sort = target.data('sort'),
                    dir = 'asc';

                $('.sorting').not(this).find('span.fa-long-arrow-alt-up, span.fa-long-arrow-alt-down').removeClass('fa-long-arrow-alt-up fa-long-arrow-alt-down');
                if (sortingIcon.hasClass('fa-long-arrow-alt-up')) {
                    sortingIcon.removeClass('fa-long-arrow-alt-up');
                    sortingIcon.addClass('fa-long-arrow-alt-down');
                    dir = 'desc';
                } else if (sortingIcon.hasClass('fa-long-arrow-alt-down')) {
                    sortingIcon.removeClass('fa-long-arrow-alt-down');
                    dir = 'restore';
                } else {
                    sortingIcon.addClass('fa-long-arrow-alt-up');
                    dir = 'asc';
                }

                me.ajax.sort(sort, dir);
            });
        },
        // Sortable UI
        sortable: function () {
            var me = this.me,
                el = me.el,
                body = el.find('.xgrid_table__body'),
                isSortable = el.attr('data-sortable');

            if (isSortable) {
                body.sortable({
                    axis: 'y',
                    containment: 'parent',
                    scroll: false,
                    tolerance: 'pointer',
                    update: function (event, ui) {
                        var item = $(ui.item),
                            next = item.next().data('order') != null ? item.next().data('order') : item.siblings().length + 1,
                            // prev = item.prev().attr('data-order'),
                            current = item.data('order'),
                            dataset = item.closest('.xgrid').attr('data-dataset');

                        xcrud.json.load(
                            '/php/actions/sort.php', {
                            dataset: dataset,
                            old: current,
                            new: next,
                            pk: pk,
                        },
                            response => {
                                me.ajax.filter();
                            }
                        );
                    },
                });
            }
        },
        cellSubmenu: function () {
            var me = this.me,
                el = me.el;

            $('.sorting .xgrid__option-menu').on('click', function (event) {
                event.stopPropagation();
                var positionTop = $(event.target).offset().top,
                    positionLeft = $(event.target).offset().left;

                $('.cellMenu').css({
                    'position': 'absolute',
                    'top': '80px',
                    'left': positionLeft,
                }).show();

                $(document).one('click', function (event) {
                    if (($(event.target).closest('.xgrid__option-menu, .cellMenu')).length === 1) {
                        return;
                    } else {
                        $('.cellMenu').hide();
                    }
                });
            });


        },
        directEdit: function () {
            $('.xgrid_table__cell').dblclick(function (event) {
                let cellText = $(event.currentTarget).text();
                $(event.currentTarget).empty();
                $(event.currentTarget).append('<input type=\'text\' class=\'xgrid_cell__input\'autofocus value=\'' + cellText + '\'>')
                $(event.currentTarget).children().focusout(function (ev) {
                    let inputText = $(ev.currentTarget).val();
                    $(ev.currentTarget).parent().text(inputText);
                    $(ev.currentTarget).remove();
                });
            });
        },
        resize: function () {
            $(window).on('resize', me.setWidth);
        },
        rowClick: function () {
            var me = this.me;
            $('div.xgrid_table__row', me.body.all).off('click'); //xbug

            $('div.xgrid_table__row', me.body.all).click(function (e) {
                var row = $(this),
                    data = row.data(),
                    url = (params.url == 'tvs' ? '/admin' : '') + data.edit;

                if ($(e.target).is('.checkboxRow')) {
                    e.stopPropagation();
                    let checkbox = $(this).find('input[type=checkbox]');
                    checkbox.click();
                }

                /* $('input[type=checkbox]').on('click', function(e) {
                    e.stopPropagation();
                }) */

                if (
                    $(e.target).is('a') ||
                    $(e.target).is('input[type=checkbox]') ||
                    $(e.target).is('.checkboxRow')
                ) {
                    return;
                }

                me.el.trigger('rowclick', data);

                row
                    .toggleClass('active-row', true)
                    .siblings().removeClass('active-row');

                if (data.edit === '') {
                    if (role.developer && !data.disableclick) {
                        // alert('Gridas neturi edit Layout');
                    }
                    return;
                }

                if (data.modal === false) {
                    xhelper.content.load(url.replace('$pk', data.pk));
                    return;
                }

                xdialog.modal.show({
                    pk: data.pk,
                    title: 'Redaguoti',
                    width: data.modalWidth
                }, url);
            });

        },
        /**
         * Visų checkbox toggle
         */
        toggleCheckbox: function () {
            var me = this.me;

            me.header.all.find('.xgrid_row-checkbox').off('click').on('click', function (e) {
                e.stopPropagation();

                var headerCheckBox = $(e.currentTarget),
                    bodyCheckBoxes = me.body.all.find('.xgrid_row-checkbox');

                bodyCheckBoxes.prop('checked', headerCheckBox.prop('checked'));
            });
        },
        archive: function () {
            var me = this.me;

            $('.xgrid_archive', me.elements.header).off('change').on('change', function (e) {
                var isArchive = $(e.currentTarget).is(':checked') ? 1 : 0;

                me.ajax.filter({
                    archive: isArchive,
                });
            });
        },
        excel: function () {
            var me = this.me,
                excel = $(me.el).find('div.xgrid_row-summary > a');

            excel.off('click').on('click', function (e) {
                e.preventDefault();

                let config = Object.assign({}, me.ajax._data, me.ajax.config.data, me.getActiveSearchFilters());

                xhelper.file.download('/php/grid/export.php', config);
            });
        },
    },
    _ajax: {
        init: function (me) {

            var ajax = this,
                fk = me.el.data('fk_val');

            ajax.parent = me;
            ajax.body = me.body;
            ajax.subpage = 0;

            // reikalinga kiekvienam requestui
            ajax._data = {
                _dataset: me.dataset,
                _params: me.datasetParams,
                pk: pk, // reikalingas pk jei submodule
                fk: fk, // papildomiem filtram
            };


            ajax.config = {
                url: '/php/grid/body.php',
                type: 'POST',
                data: {},
                //dataType: 'json',
                success: function (response) {
                    if (typeof ajax.callback === 'function') {
                        ajax.callback(response);
                    }

                    ajax.callback = null;
                    ajax.config.url = '/php/grid/body.php';
                    ajax.loading = false;

                    me.listeners.initBody();
                    xlisteners.ajax();
                },
            };

            return ajax;
        },
        load: function () {
            this.loading = true;

            var config = $.extend(this.config, {});
            config.data = $.extend(config.data, this._data);

            $.ajax(config);
        },
        /**
         * Grid filtravimas
         * 
         * @param {object} data filtruojamos reiksmes, key - stulpelio pavadimas, value - ieskoma reiksme
         * @param {boolean} extend ar pilnai perrasyti ajax.data
         */
        filter: function (data, extend = true) {

            var ajax = this,
                body = ajax.body,
                me = ajax.parent,
                elements = me.elements;

            ajax.reset();

            ajax.config.data._type = 'filter';
            ajax.config.data = extend ? $.extend(ajax.config.data, data) : data;


            //debugger;

            ajax.callback = function (response) {
                body.center.html(response.center);
                body.left.html(response.left);
                elements.summary.html(response.summary);
                elements.footer.html(response.paging);
            };

            ajax.load();
        },
        sort: function (column, dir) {
            var ajax = this,
                body = ajax.body,
                me = ajax.parent;

            ajax.reset();

            ajax.config.data = $.extend(ajax.config.data, {
                _type: 'sort',
                _orderBy: column,
                _orderDir: dir,
            });

            ajax.callback = function (response) {
                body.center.html(response.center);
                body.left.html(response.left);
            };

            ajax.load();
        },
        scroll: function () {
            //return;
            var ajax = this,
                body = ajax.body,
                me = ajax.parent;

            ajax.subpage = ajax.subpage + 1;

            ajax.config.data._type = 'scroll';
            ajax.config.data._subpage = ajax.subpage;

            ajax.callback = function (response) {
                body.center.append(response.center);
                body.left.append(response.right);

            };

            ajax.load();
        },
        reset: function () {
            var ajax = this;

            delete ajax.config.data._subpage;
            ajax.subpage = 0;
        },
        loadFilter: function (filter, list) {
            var ajax = this,
                me = ajax.parent;
            xcrud.load('/php/grid/filter.php', {
                _dataset: me.dataset,
                filter: filter,
            }, function (response) {
                list.empty();
                list.html(response);
            });
        },
    },
    _columnResize: {
        colWidths: new Array,
        init: function (el, config) {
            let defaults = {
                orientations: ['e'],
            },
                params = Object.assign(defaults, config),
                handles = '';

            params.orientations.forEach((orientation) => {
                handles += `<div class="xgrid_resize__${orientation}"></div>`;
            });

            $(el).each((i, el) => {

                $(el).addClass('xgrid_resize').append(handles);
            });
            this.initResize();
            this.gridIdentifyer = $(el).closest('.xgrid').data('dataset');
            return this;
        },
        initResize: function () {
            $('.xgrid_resize__e').mousedown((e) => {
                e.stopPropagation();
                let handle = $(e.currentTarget),
                    col = handle.parent(),
                    startX = e.clientX,
                    startWidth = col.width();
                // console.log(this.el);

                $(document).mousemove({
                    col: col,
                    startX: startX,
                    startWidth: startWidth,
                    colWidths: this.colWidths,
                    gridIdentifyer: this.gridIdentifyer,
                }, this.doResize);
                $(document).mouseup({
                    colWidths: this.colWidths,
                    gridIdentifyer: this.gridIdentifyer,
                }, this.stopResize);
            });
        },
        doResize: function (e) {
            let col = e.data.col,
                startX = e.data.startX,
                startWidth = e.data.startWidth,
                grid = col.closest('.xgrid'),
                rows = grid.find('.xgrid_table__row'),
                colIndex = col.index(),
                newWidth = startWidth + e.clientX - startX,
                tmpStyle = $('<style id="gridStyleTmp"/>');

            col[0].style.maxWidth = `${newWidth}px`;
            col[0].style.minWidth = `${newWidth}px`;
            rows.each((i, el) => {
                $(el).find('.cell')[colIndex].style.maxWidth = `${newWidth}px`;
                $(el).find('.cell')[colIndex].style.minWidth = `${newWidth}px`;
            });
            if ($('#gridStyleTmp').length === 0) {
                $('#content').append(tmpStyle);
            }
            tmpStyle.html(
                `
					.xgrid[data-dataset="${e.data.gridIdentifyer}"] .cell:nth-child(${colIndex + 1}){
						flex-basis:${newWidth}px!important;
						flex-grow:0;
						flex-shrink:0;
					}
				`
            );
            e.data.colWidths[colIndex] = newWidth;

        },
        stopResize: function (e) {
            $('#gridStyleTmp').remove();
            let colWidths = e.data.colWidths,
                colStyles = '';
            colWidths.forEach((el, i) => {
                if (el) {
                    colStyles +=
                        `
						.xgrid[data-dataset="${e.data.gridIdentifyer}"] .cell:nth-child(${i + 1}){
							flex-basis:${el}px!important;
							flex-grow:0;
							flex-shrink:0;
						}
					`;
                }
            });
            if ($('#grid-style').length === 0) {
                $('#content').prepend($('<style id="grid-style"></style>').html(colStyles));
            } else {
                $('#grid-style').html(colStyles);
            }

            e.stopPropagation();
            $(document).off('mousemove');
            $(document).off('mouseup');
        },
    },
}